<template>
  <div class="portal-screen">
    <ai-yuigon-banner-placeholder></ai-yuigon-banner-placeholder>
    <ul class="block-menu mb2">
      <li class="block-menu-item">
        <router-link to="/about-me">
          <figure class="block-menu-item-img">
            <img class="fit-img about-me-img" src="@/images/top/相続のせんせい.png" alt="「相続のせんせい」とは">
            <div class="block-menu-item-img-hover gtm_top_senseitoha_t" v-show="!isMobile">
              <div class="block-menu-item-img-hover-label gtm_top_senseitoha_t">詳しく見る<i class="fas fa-chevron-right"></i></div>
            </div>
            <!-- div class="block-menu-item-img-tab">新規</div -->
          </figure>
          <div class="block-menu-item-cnt gtm_top_senseitoha_t">
            <div class="block-menu-item-cnt-title gtm_top_senseitoha_t">「相続のせんせい」とは</div>
            <p class="block-menu-item-cnt-text mt1 gtm_top_senseitoha_t">
              「相続のせんせい」では何ができるの？まずはこちらをご覧ください。
            </p>
          </div>
        </router-link>
      </li>
    </ul>
    <div class="info pb-10px pt-10px" v-if="dataPortal.length > 0">
      <ul class="info-list">
        <li class="info-emergency-item" v-for="item in dataPortal" :key="item.id">
          <a class="flex flex-bet"  v-if="item.messageType==1">
            <div class="info-list-item-tab">
                             <span class="info-list-item-tab-item alert">
                                <i class="fas fa-exclamation-triangle"></i><span>緊急メッセージ</span>
                            </span>
            </div>
            <div class="info-list-item-cnt" style="cursor: pointer;">
              <a @click="handleClickRefer(item.id)">{{ item.title }}</a>
            </div>
          </a>
          <a class="flex flex-bet"  v-else>
            <div class="info-list-item-tab">
                             <span class="info-list-item-tab-item topics">
                                <i class="far fa-bell"></i><span>お知らせ</span>
                            </span>
            </div>
            <div class="info-list-item-cnt" style="cursor: pointer;">
              <a @click="handleClickRefer(item.id)">{{ item.title }}</a>
            </div>
          </a>
        </li>
      </ul>
      <div class="mt-2 text-center" style="margin-top: 16px">
        <div class="emergency-btn-bottom">
          <label v-show="total">({{totalRecord}})</label>
          <el-button type="danger" @click="showMsg(dataSearch.length -1)" v-show="msgDown">もっと見る<i
                  class="fas fa-chevron-down"></i></el-button>
          <el-button type="success" @click="showMsg(0)" v-show="msgUp">閉じる<i class="fas fa-chevron-up"></i></el-button>
        </div>
      </div>
    </div><!--info-->
    <ul class="block-menu flex flex-bet mt2">
      <li class="block-menu-item" v-bind:class="{ col2: isMobile, col3: !isMobile }">
        <router-link to="/search-tax">
          <figure class="block-menu-item-img">
            <img class="fit-img" src="@/images/top/相続税を調べる.png" alt="相続税額を調べる">
            <div class="block-menu-item-img-hover gtm_top_siraberu_t" v-show="!isMobile">
              <div class="block-menu-item-img-hover-label gtm_top_siraberu_t">詳しく見る<i class="fas fa-chevron-right"></i></div>
            </div>
<!--            <div class="block-menu-item-img-tab">新規</div>-->
          </figure>
          <div class="block-menu-item-cnt gtm_top_siraberu_t">
            <div class="block-menu-item-cnt-title gtm_top_siraberu_t">相続税額を調べる</div>
            <p class="block-menu-item-cnt-text mt1 gtm_top_siraberu_t">
              最寄駅や資産情報から相続税がどれくらいかかるかお教えします。
            </p>
          </div>
        </router-link>
      </li>
      <li class="block-menu-item" v-bind:class="{ col2: isMobile, col3: !isMobile }">
        <router-link to="/diagnosis">
          <figure class="block-menu-item-img">
            <img class="fit-img" src="@/images/top/モメ度診断.png" alt="モメ度診断">
            <div class="block-menu-item-img-hover gtm_top_momedo_t" v-show="!isMobile">
              <div class="block-menu-item-img-hover-label gtm_top_momedo_t">詳しく見る<i class="fas fa-chevron-right"></i></div>
            </div>
<!--            <div class="block-menu-item-img-tab">新規</div>-->
          </figure>
          <div class="block-menu-item-cnt gtm_top_momedo_t">
            <div class="block-menu-item-cnt-title gtm_top_momedo_t">相続モメ度診断<br>～モメない先の杖～</div>
            <p class="block-menu-item-cnt-text mt1 gtm_top_momedo_t">
              質問に答えるだけで、相続でモメる可能性を診断できます。
            </p>
          </div>
        </router-link>
      </li>
      <li class="block-menu-item" v-bind:class="{ col2: isMobile, col3: !isMobile }">
        <a href="https://legacy.ne.jp/forCustomer/ai-yuigon-well-b/" target="_blank" rel="noopener noreferrer">
          <figure class="block-menu-item-img">
            <img v-if="isMobile" class="fit-img" src="@/images/top/遺言書草案_SP.png" alt="遺言書草案を作りたい方へ">
            <img v-else class="fit-img" src="@/images/top/遺言書草案_PC.png" alt="遺言書草案を作りたい方へ">
            <div class="block-menu-item-img-hover gtm_top_yuigon_t" v-show="!isMobile">
              <div class="block-menu-item-img-hover-label gtm_top_yuigon_t">詳しく見る<i class="fas fa-chevron-right"></i></div>
            </div>
          </figure>
          <div class="block-menu-item-cnt gtm_top_yuigon_t">
            <div class="block-menu-item-cnt-title gtm_top_yuigon_t">遺言書草案を作りたい方へ</div>
            <p class="block-menu-item-cnt-text mt1 gtm_top_yuigon_t">
              AIコンシェルジュ猫の「まだない」が、遺言書の草案を自動生成します。
            </p>
          </div>
        </a>
      </li>
      <li class="block-menu-item" v-bind:class="{ col2: isMobile, col3: !isMobile }">
        <router-link to="/invoiceFlag">
          <figure class="block-menu-item-img">
            <img class="fit-img" src="@/images/top/相続手続きチェックリスト.png" alt="相続手続きチェックリスト">
            <div class="block-menu-item-img-hover gtm_top_checklist_t" v-show="!isMobile">
              <div class="block-menu-item-img-hover-label gtm_top_checklist_t">詳しく見る<i class="fas fa-chevron-right"></i></div>
            </div>
<!--            <div class="block-menu-item-img-tab">新規</div>-->
          </figure>
          <div class="block-menu-item-cnt gtm_top_checklist_t">
            <div class="block-menu-item-cnt-title gtm_top_checklist_t">相続手続きチェックリスト</div>
            <p class="block-menu-item-cnt-text mt1 gtm_top_checklist_t">
              相続手続き作業をわかりやすいチェックリストにしました。
            </p>
          </div>
        </router-link>
      </li>
      <li class="block-menu-item" v-bind:class="{ col2: isMobile, col3: !isMobile }">
        <router-link to="/category">
          <figure class="block-menu-item-img">
            <img class="fit-img" src="@/images/top/読んで分かる相続.png" alt="読んでわかる相続">
            <div class="block-menu-item-img-hover gtm_top_yonndewakaru_t" v-show="!isMobile">
              <div class="block-menu-item-img-hover-label gtm_top_yonndewakaru_t">詳しく見る<i class="fas fa-chevron-right"></i></div>
            </div>
<!--            <div class="block-menu-item-img-tab">新規</div>-->
          </figure>
          <div class="block-menu-item-cnt gtm_top_yonndewakaru_t">
            <div class="block-menu-item-cnt-title gtm_top_yonndewakaru_t">読んでわかる相続</div>
            <p class="block-menu-item-cnt-text mt1 gtm_top_yonndewakaru_t">
              難しいイメージのある相続をわかりやすい読み物にしました。
            </p>
          </div>
        </router-link>
      </li>
      <li class="block-menu-item" v-bind:class="{ col2: isMobile, col3: !isMobile }">
        <router-link to="/seminar">
          <figure class="block-menu-item-img">
            <img class="fit-img" src="@/images/top/セミナー申し込み.png" alt="セミナー申し込み">
            <div class="block-menu-item-img-hover gtm_top_seminar_t" v-show="!isMobile">
              <div class="block-menu-item-img-hover-label gtm_top_seminar_t">詳しく見る<i class="fas fa-chevron-right"></i></div>
            </div>
<!--            <div class="block-menu-item-img-tab">新規</div>-->
          </figure>
          <div class="block-menu-item-cnt gtm_top_seminar_t">
            <div class="block-menu-item-cnt-title gtm_top_seminar_t">セミナー申し込み</div>
            <p class="block-menu-item-cnt-text mt1 gtm_top_seminar_t">
              税理士法人レガシィでは定期的に無料セミナーを開催しています。
            </p>
          </div>
        </router-link>
      </li>
    </ul>
    <div class="register-button" :class="isMobile ? 'register-button-mobile': ''">
      <el-button class="el-button-big" @click="handleRegister">無料会員登録</el-button>
      <el-button class="el-button-big" @click="handleContact">相続のご相談はこちら</el-button>
    </div>
  </div>
</template>
<script>
    import { isMobile } from 'mobile-device-detect'
    import { mapGetters } from 'vuex'
    import portal from '@/api/portal/portal-cl.js'
    import { SET_OPEN_REGISTER_DIALOG } from '@/store/actions.type'
    import AiYuigonBannerPlaceholder from '@/components/client/AiYuigonBannerPlaceholder.vue'

    export default {
        components: {
            'ai-yuigon-banner-placeholder': AiYuigonBannerPlaceholder
        },
        data () {
            return {
                isMobile: isMobile,
                dataPortal: [],
                dataSearch: [],
                countMsg: 1,
                indexShowMsg: 0,
                msgUp: false,
                msgDown: false,
                totalRecord: '',
                total: false,
                isNotLogin: true
            }
        },
        created () {
            this.getDataPortal()
            this.fetchData()
            this.$bus.$on('refreshData', (data) => {
                if (this.$route.name === data) {
                    this.fetchData()
                }
            })
        },
        mounted () {
            if (this.isAuthenticated) {
                this.$router.push({ name: 'portalMember' })
            }
        },
        computed: {
            ...mapGetters(['currentUser', 'isAuthenticated'])
        },
        methods: {
            fetchData () {
                let memberId = this.currentUser.id === undefined ? '' : this.currentUser.id
                if (parseInt(memberId) > 0) {
                    this.isNotLogin = false
                }
            },
            getDataPortal () {
                portal.searchPortal().then(response => {
                    this.dataSearch = []
                    let allData = []
                    response.data.data.forEach(function (item, index) {
                        if (item.category === 1) {
                            allData.push({ 'id': item.id, 'category': item.category, 'title': item.title, 'messageType': item.messageType })
                        }
                    })
                    this.dataSearch = allData
                    this.showMsg(0)
                })
            },
            showMsg (num) {
                this.indexShowMsg = this.countMsg + num
                let numberRecord = this.indexShowMsg
                if (numberRecord > this.countMsg) {
                    this.msgUp = true
                    this.total = true
                    this.msgDown = false
                } else {
                    this.msgUp = false
                    this.total = false
                }
                let dataShow = this.dataSearch
                this.dataPortal = []
                let _this = this
                dataShow.forEach(function (item, index) {
                    if (numberRecord > index) {
                        _this.dataPortal.push({ 'id': item.id, 'category': item.category, 'title': item.title, 'messageType': item.messageType, 'content': item.content })
                    }
                })
                if (dataShow.length > this.countMsg && this.msgUp === false) {
                    this.msgDown = true
                }
                this.totalRecord = this.dataPortal.length + '/' + dataShow.length
            },
            handleClickRefer (id) {
              this.$router.push({ name: 'messageDetail', params: { id: id } })
            },
            handleRegister () {
                this.$store.dispatch(SET_OPEN_REGISTER_DIALOG, true)
            },
            handleContact () {
                let routeData = this.$router.resolve({ name: 'contact' })
                window.open(routeData.href, '_blank')
            }
        }
    }
</script>
<style scoped>
  @import "portal.css";
  .portal-screen .register-button button {
    width: 250px !important;
  }
  .portal-screen .register-button-mobile button {
    margin-top: 10px;
  }
  .portal-screen .register-button-mobile .el-button+.el-button {
    margin-left: 0px !important;
  }
</style>
